import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  actionHref?: string;
  actionLabel?: string;
}

export default function SectionHeading({ eyebrow, title, desc, actionHref, actionLabel }: SectionHeadingProps) {
  return (
    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8">
      <div className="max-w-2xl">
        <p className="flex items-center gap-2 text-xs font-medium tracking-widest text-primary-600 uppercase">
          <span className="inline-block w-6 h-px bg-primary-500" />
          {eyebrow}
        </p>
        <h2 className="mt-3 font-heading text-xl md:text-3xl font-bold text-foreground-950">{title}</h2>
        {desc && <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-600">{desc}</p>}
      </div>
      {actionHref && actionLabel && (
        <Link
          to={actionHref}
          className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-700 whitespace-nowrap hover:text-primary-500 transition-colors cursor-pointer shrink-0"
        >
          {actionLabel}
          <i className="ri-arrow-right-line" />
        </Link>
      )}
    </div>
  );
}